import React, { useContext } from 'react';
import { useSelector } from '@xstate/react';

import { SkeletonLoader } from '@chargify/custom-ui-components';
import PaymentProfilesReplace from '../../components/PaymentProfilesReplace';
import {
  PaymentProfileInterpreter,
  paymentProfileSelectors,
  paymentProfilesSelectors,
} from '../../machines';
import { PaymentProfilesContext } from '../../contexts';
import PaymentProfilesReplaceAlerts from '../../components/PaymentProfilesReplaceAlerts';

type Props = {
  /**
   * Payment profile machine reference
   */
  paymentProfileRef: PaymentProfileInterpreter;
};
export const ReplacePaymentProfilesContainer = ({
  paymentProfileRef,
}: Props) => {
  const { paymentProfilesService } = useContext(PaymentProfilesContext);
  const paymentProfiles = useSelector(
    paymentProfilesService,
    paymentProfilesSelectors.getPaymentProfiles
  );

  const selectedPaymentProfilesIds = useSelector(
    paymentProfileRef,
    paymentProfileSelectors.getPaymentProfilesIdsForReplacement
  );
  const subscriptions = useSelector(
    paymentProfileRef,
    paymentProfileSelectors.getPaymentProfilesSubscriptions
  );
  const isPaymentProfilesReplacementError = useSelector(
    paymentProfileRef,
    paymentProfileSelectors.getPaymentProfilesReplacementError
  );
  const isPaymentProfilesReplacementProcessing = useSelector(
    paymentProfileRef,
    paymentProfileSelectors.getPaymentProfilesReplacementProcessing
  );

  if (!paymentProfiles.length) {
    return null;
  }

  return isPaymentProfilesReplacementError ? (
    isPaymentProfilesReplacementProcessing ? (
      <SkeletonLoader height={200} />
    ) : (
      <PaymentProfilesReplaceAlerts
        subscriptions={subscriptions}
        onRetry={() =>
          paymentProfileRef.send({ type: 'RETRY_REPLACE_PAYMENT_PROFILES' })
        }
      />
    )
  ) : (
    <PaymentProfilesReplace
      paymentProfiles={paymentProfiles}
      onPaymentProfileSelected={(id) =>
        paymentProfileRef.send({
          type: 'SET_PAYMENT_PROFILES_ID_FOR_REPLACEMENT',
          paymentProfileId: id,
        })
      }
      selectedPaymentProfilesIds={selectedPaymentProfilesIds}
    />
  );
};
